import React from 'react';
import PropTypes from 'prop-types';
import {
  Box, Typography, Paper, IconButton, Button, CircularProgress,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import MicIcon from '@mui/icons-material/Mic';

function NoteView({
  note, isGeneratingNote, onRegenerate, onContinue,
}) {
  return (
    <Box>
      <Box
        sx={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2,
        }}
      >
        <Typography variant="subtitle1" fontWeight={600}>
          Note
        </Typography>
        <IconButton size="small" onClick={() => navigator.clipboard.writeText(note)}>
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Box>

      <Paper
        variant="outlined"
        sx={{
          p: 2,
          bgcolor: 'grey.50',
          whiteSpace: 'pre-wrap',
          maxHeight: 300,
          overflow: 'auto',
          fontSize: '0.875rem',
          borderRadius: 2,
          mb: 2,
        }}
      >
        {note}
      </Paper>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        <Button
          variant="contained"
          startIcon={isGeneratingNote ? <CircularProgress size={18} color="inherit" /> : <AutoAwesomeIcon />}
          onClick={onRegenerate}
          disabled={isGeneratingNote}
          fullWidth
          sx={{ py: 1.5, borderRadius: 2, textTransform: 'none' }}
        >
          Regenerate Note
        </Button>
        <Button
          variant="outlined"
          startIcon={<MicIcon />}
          onClick={onContinue}
          fullWidth
          sx={{ py: 1.5, borderRadius: 2, textTransform: 'none' }}
        >
          Continue Listening
        </Button>
      </Box>
    </Box>
  );
}

NoteView.propTypes = {
  note: PropTypes.string.isRequired,
  isGeneratingNote: PropTypes.bool.isRequired,
  onRegenerate: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
};

export default NoteView;
